import React, { useContext } from 'react';
import styles from './Footer.module.css';
import getProfileData from '../../data/profileData';
import { LanguageContext } from '../../contexts/LanguageContext';
import ThemeSwitcher from '../ThemeSwitcher/ThemeSwitcher';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

function Footer() {
  const { language } = useContext(LanguageContext);
  const { footer } = getProfileData(language);

  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <div className={styles.contact}>
          <span className={styles.contactLabel}>{footer.contact}</span>
          <a href={footer.telegramUrl} className={styles.contactLink} target="_blank" rel="noopener noreferrer">
            {footer.telegramUsername}
          </a>
        </div>
        <div className={styles.switchersContainer}>
          <LanguageSwitcher />
          <ThemeSwitcher />
        </div>
      </div>
      <div className={styles.copyright}>
        {footer.copyright}
      </div>
    </footer>
  );
}

export default Footer;